import { apiSlice } from "features/api/apiSlice";

const uploadImage = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    uploadImage: build.mutation({
      query: (data) => ({
        url: "/upload",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) {
          return ["User"];
        }
      },
    }),
  }),
});

export const { useUploadImageMutation } = uploadImage;
